<template>
  <section class="most-popular-section">
    <div class="container">
      <h2 class="section-title">Most popular</h2>
      <div class="articles">
        <div
          ref="carousel"
          class="items"
          :style="`left:${dataItems.left}`"
        >
          <ArticleCard
            v-for="(article, index) in articles"
            :id="`most-popular-article-${index}`"
            :key="index"
            :article="article"
            theme="dark"
          />
        </div>
        <div class="dots">
          <div
            v-for="(article, index) in articles"
            :key="index"
            class="dot"
            :class="dataItems.index === index && 'active'"
          ></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ArticleCard from '~/components/Common/ArticleCard/ArticleCard.vue';
import carousel from '~/mixins/carousel';
import { useJournalStore } from '~/stores/journal';

export default {
  components: {
    ArticleCard,
  },
  mixins: [carousel],
  data() {
    return {
      journalStore: useJournalStore(),
    };
  },
  computed: {
    articles() {
      return this.journalStore?.popularArticles;
    },
  },
  methods: {
    setActiveItem(direction, isMobile = true) {
      const currentIndex = this.dataItems.index;
      const articleWidth = document.getElementById(
        'most-popular-article-0'
      ).clientWidth;
      const lastIndex = this.articles?.length - (isMobile ? 1 : 2);
      const newIndex =
        direction === 'next' ? currentIndex + 1 : currentIndex - 1;
      const increment = direction === 'next' ? -1 : 1;
      const offset = direction !== 'next' ? -20 : 20;

      if (newIndex < 0 || newIndex > lastIndex) {
        return;
      }
      this.dataItems = {
        left: `${this.dataItems.value + increment * articleWidth - offset}px`,
        value: this.dataItems.value + increment * articleWidth - offset,
        index: newIndex,
        transition: '0.6s',
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import './MostPopularSection.scss';
</style>
